import { render, staticRenderFns } from "./StatisticWidgetTotalEvent.vue?vue&type=template&id=6452f322&"
import script from "./StatisticWidgetTotalEvent.vue?vue&type=script&lang=js&"
export * from "./StatisticWidgetTotalEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports